import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7db747d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col text-left" }
const _hoisted_2 = { class: "font-bold text-2xl text-textPrimary" }
const _hoisted_3 = { class: "p-4" }
const _hoisted_4 = { class: "flex flex-row flex-wrap justify-center items-center gap-2 px-4" }
const _hoisted_5 = {
  key: 0,
  class: "chip chip-conflict",
  "data-testid": "expanded-conflict-count"
}
const _hoisted_6 = {
  key: 1,
  class: "chip chip-open",
  "data-testid": "expanded-open-count"
}
const _hoisted_7 = {
  key: 2,
  class: "chip chip-doctor",
  "data-testid": "expanded-closed-count"
}
const _hoisted_8 = {
  key: 3,
  class: "chip chip-unidentified",
  "data-testid": "expanded-unidentified-count"
}
const _hoisted_9 = {
  key: 4,
  class: "chip chip-blocked",
  "data-testid": "expanded-blocked-count"
}
const _hoisted_10 = {
  class: "chip-icon",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_11 = ["d"]
const _hoisted_12 = {
  class: "chip chip-total",
  "data-testid": "expanded-total-count"
}
const _hoisted_13 = { class: "flex justify-end p-4" }

import { ref, computed, PropType, watch } from 'vue'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import ManagementDoctorTable from '../components/ManagementDoctorTable.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import { mdiLock } from '@mdi/js'

interface TableHeader {
  key: string
  label: string
}

type ModalMode = 'remove' | 'allocate' | 'change'

const itemsToShow = 15

export default /*#__PURE__*/_defineComponent({
  __name: 'ExpandedTableModal',
  props: {
  showModal: {
    type: Boolean,
    required: true
  },
  headers: {
    type: Array as PropType<TableHeader[]>,
    required: true
  },
  items: {
    type: Array as PropType<any[]>,
    required: true
  },
  mode: {
    type: String as PropType<ModalMode>,
    required: true,
    validator: (value: string) => ['remove', 'allocate', 'change'].includes(value)
  },
  conflictCount: {
    type: Number,
    required: true
  },
  openCount: {
    type: Number,
    required: true
  },
  closedCount: {
    type: Number,
    required: true
  },
  totalCount: {
    type: Number,
    required: true
  },
  unidentifiedCount: { type: Number as PropType<number | null>, default: null },
  // Título do modal de origem (ex.: "Editar responsável"); sem ele, cai no título do modo.
  title: { type: String as PropType<string | null>, default: null },
  blockedCount: { type: Number as PropType<number | null>, default: null }
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;





const shiftsShownCount = ref(itemsToShow)

const displayedItems = computed(() => {
  return props.items.slice(0, shiftsShownCount.value)
})

const titles: Record<ModalMode, string> = {
  remove: 'Remover médico',
  allocate: 'Alocar médico',
  change: 'Alterar médico'
}

const modalTitle = computed(() => props.title || titles[props.mode])

const conflictShiftsText = computed(() => {
  const plural = props.conflictCount !== 1
  return `+${props.conflictCount} plant${plural ? 'ões' : 'ão'} com conflit${plural ? 'os' : 'o'}`
})

const openShiftsText = computed(() => {
  const plural = props.openCount !== 1
  return `+${props.openCount} plant${plural ? 'ões' : 'ão'} abert${plural ? 'os' : 'o'}`
})

const closedShiftsText = computed(() => {
  const plural = props.closedCount !== 1
  return `+${props.closedCount} plant${plural ? 'ões' : 'ão'} com médico`
})

const unidentifiedShiftsText = computed(() => {
  const n = props.unidentifiedCount ?? 0
  return `+${n} plant${n !== 1 ? 'ões' : 'ão'} ocupad${n !== 1 ? 'os' : 'o'} s/ ident.`
})

const blockedShiftsText = computed(() => {
  const n = props.blockedCount ?? 0
  return `+${n} plant${n !== 1 ? 'ões' : 'ão'} bloquead${n !== 1 ? 'os' : 'o'}`
})

const totalShiftsText = computed(() => {
  const plural = props.totalCount !== 1
  return `+${props.totalCount} plant${plural ? 'ões' : 'ão'}`
})

function showMore() {
  shiftsShownCount.value += itemsToShow
}

function close() {
  emit('close')
}

watch(
  () => props.items,
  () => {
    shiftsShownCount.value = itemsToShow
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalVue, {
    modalActive: __props.showModal,
    onClose: close,
    hasHeaderBorder: true,
    size: "large"
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(modalTitle.value), 1)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(FilledButton, {
          height: "48px",
          width: "100px",
          onClick: close,
          class: "bg-primary30"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Fechar")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ManagementDoctorTable, {
          headers: __props.headers,
          items: displayedItems.value
        }, null, 8, ["headers", "items"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (__props.conflictCount)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(conflictShiftsText.value), 1))
          : _createCommentVNode("", true),
        (__props.openCount)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(openShiftsText.value), 1))
          : _createCommentVNode("", true),
        (__props.closedCount)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(closedShiftsText.value), 1))
          : _createCommentVNode("", true),
        (__props.unidentifiedCount)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(unidentifiedShiftsText.value), 1))
          : _createCommentVNode("", true),
        (__props.blockedCount)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
              (_openBlock(), _createElementBlock("svg", _hoisted_10, [
                _createElementVNode("path", { d: _unref(mdiLock) }, null, 8, _hoisted_11)
              ])),
              _createTextVNode(" " + _toDisplayString(blockedShiftsText.value), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_12, _toDisplayString(totalShiftsText.value), 1),
        (displayedItems.value.length < __props.items.length)
          ? (_openBlock(), _createElementBlock("button", {
              key: 5,
              onClick: showMore,
              class: "text-primary30 font-bold cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
            }, " Ver mais "))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modalActive"]))
}
}

})